<template>
    <div id="App">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>
<style scoped>
    #App{
        width: 100%;
        height: 100%;
    }
</style>
